import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { GoToTop } from './../../Commons/GoToTop'


const SecondaryBase = ({ children, actionToExecute = null, classNameApplied, urlToGo = null }) => {
    const navigate = useNavigate()


    const ActionToExecute = () => {
        try {
            actionToExecute()
        } catch (error) {
            
        }
    }

    const Logout = async () => {
        try {
            navigate("/admin")
        } catch (error) {
            
        }
    }

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            <header className={`Header__Secondary container ${classNameApplied && classNameApplied !== '' ? classNameApplied : ''}`}>
                {classNameApplied && classNameApplied !== '' ? (
                    <button type='button' className='Header__Secondary__Buttons Btn__Adsl--WhiteOutlineTransparent' onClick={Logout}>
                        <i className="bi bi-box-arrow-right"></i>
                    </button>
                ) : (
                    <button type='button' className='Header__Secondary__Buttons Btn__Adsl--RedOutline' onClick={Logout}>
                        <i className="bi bi-box-arrow-right"></i>
                    </button>
                )}
            </header>

            <main className={`container Dashboard Container-FullHeight ${classNameApplied && classNameApplied !== '' ? classNameApplied : ''}`}>
                <div className="ReturnButton">
                    {classNameApplied && classNameApplied !== '' ? (
                        urlToGo && urlToGo !== '' ? (
                            <button className='ReturnButton__Button__White' onClick={() => navigate(urlToGo)}>
                                <i className="bi bi-arrow-90deg-left fs-5"></i>
                            </button>
                        ) : (
                            <button className='ReturnButton__Button__White' onClick={() => ActionToExecute()}>
                                <i className="bi bi-arrow-90deg-left fs-5"></i>
                            </button>
                        )
                    ) : (
                        urlToGo && urlToGo !== '' ? (
                            <button className='ReturnButton__Button' onClick={() => navigate(urlToGo)}>
                                <i className="bi bi-arrow-90deg-left fs-5"></i>
                            </button>
                        ) : (
                            <button className='ReturnButton__Button' onClick={() => ActionToExecute()}>
                                <i className="bi bi-arrow-90deg-left fs-5"></i>
                            </button>
                        )
                    )}
                </div>

                <div className="row mt-3">
                    {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL" alt="Logo" /> */}
                    <img src="/img/page/adsl-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />

                    <div className="mt-5">
                        {children}
                    </div>
                </div>
            </main>

            <GoToTop />

            <footer className={`container ${classNameApplied && classNameApplied !== '' ? classNameApplied : ''}`}>
                {classNameApplied && classNameApplied !== '' ? (
                    <p className='text-center text-white FooterCredits'>Hecho con ♥ por Interaktia | 2026</p>
                ) : (
                    <p className='text-center FooterCredits'>Hecho con ♥ por Interaktia | 2026</p>
                )}
            </footer>
        </>
    )
}

export { SecondaryBase };